import { render, staticRenderFns } from "./ErrorLanding.vue?vue&type=template&id=4d7b7a6e&scoped=true"
import script from "./ErrorLanding.vue?vue&type=script&lang=js"
export * from "./ErrorLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7b7a6e",
  null
  
)

export default component.exports